import { Component, HostBinding, OnInit } from '@angular/core';
import { animate, style, transition, trigger } from '@angular/animations';

@Component({
  selector:    'app-spinner',
  templateUrl: './spinner.component.html',
  styleUrls:   [ './spinner.component.scss' ],
  animations:  [
    trigger('easeInOut', [
      transition('void => *', [
        style({ opacity: 0 }),
        animate('.5s ease-in-out', style({ opacity: 1 }))
      ]),
      transition('* => void', [
        animate('.5s ease-in-out', style({ opacity: 0 }))
      ])
    ])
  ]
})


export class SpinnerComponent implements OnInit {

  @HostBinding('@easeInOut')

  text: string;

  constructor() {
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/projektyWeb/McComp_Flota/Front/src/app/services/spinner/spinner/spinner.component.ts